<template>
	<span class="icon">
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve">
			<g><path d="M500,982.1C229.7,982.1,10,765.5,10,500C10,234.5,229.7,17.9,500,17.9S990,234.5,990,500C990,765.5,770.3,982.1,500,982.1z M500,49.5C247.1,49.5,41.6,251.8,41.6,500S247.1,950.5,500,950.5S958.4,748.2,958.4,500S752.9,49.5,500,49.5z"/><path d="M373.5,270.8L373.5,270.8c17.4,0,31.6,14.2,31.6,31.6v411c0,17.4-14.2,31.6-31.6,31.6l0,0c-17.4,0-31.6-14.2-31.6-31.6v-411C341.9,285,356.2,270.8,373.5,270.8z"/><path d="M610.6,270.8L610.6,270.8c17.4,0,31.6,14.2,31.6,31.6v411c0,17.4-14.2,31.6-31.6,31.6l0,0c-17.4,0-31.6-14.2-31.6-31.6v-411C579,285,593.3,270.8,610.6,270.8z"/></g>
		</svg>
	</span>	
</template>

<script>
	export default {
		name: "PauseIcon"
	}
</script>

<style scoped>

.icon {
	fill: #fff;
	width: 1.5rem;
	z-index: 1;
	display: block;
	margin: 0;
}

</style>




// WEBPACK FOOTER //
// src/icons/PauseIcon.vue